import { render } from "./LayoutDefault.vue?vue&type=template&id=2ffa6a0d&ts=true"
import script from "./LayoutDefault.vue?vue&type=script&lang=ts"
export * from "./LayoutDefault.vue?vue&type=script&lang=ts"

import "./LayoutDefault.vue?vue&type=style&index=0&id=2ffa6a0d&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__